import PageList from "../abstract/PageList.js";
import GridWrapper from "../../su/GridWrapper.js";

export default class PageLookupList extends PageList {
	constructor() {
		super();
	}

	initList() {
		// h
		let h = this.getAvailableHeight();
		

		//
		this.theGrid = new GridWrapper($(".jsList"));

		let options = {
			dataSource: {
				// data: $data.rows,
			},
			sorting: {
				multiple: false,
				allowUnsort: false
			},
			paging: {
				pageSize: 12,
				pageLinksCount: 10
			},
			//rowHover: false,
			altRows: false,

			columns: [
				{
					field: "LabelList",
					title: "Label"
				},
				{
					field: "StatusLabel",
					title: "Status"
				},
				{
					title: "ACTION",
					width: "150px",
					// field: "_idx",
					columnTemplate: this.theGrid.prepareColumnTemplate($("#customActions"), this.initListButton.bind(this))
				}
			],
			// TODO
			scrolling: true,
			resizing: true,
			height: h+"px"
		}

		this.theGrid.create(options, this.data.rows);
		this.theGrid.enableSearch($(".jsListSearch"), {
			or: [
				{ path: "Label", filter: "contains", value: "" },
				{ path: "StatusLabel", filter: "contains", value: "" }
			]
		});
		this.theGrid.init("jsList");
		// var a = StateManager.getViewState("jsList")
		jQuery(window).on("resize.grid", this.onResize.bind(this));

		return;
	}

	getAvailableHeight() {
		let a = jQuery(".js-size");
		let i = 0;
		for (let x = 0; x < a.length; x++) {
			i += jQuery(a[x]).outerHeight();
		}
		i += 50; // padding app container
		i += 78; // search box
		i += 143; // paging
		let h = jQuery(window).height() - i;
		return h;
	}

	onResize(e) {
		//debugger;
		this.theGrid.setHeight(this.getAvailableHeight());
	}


}

